import { Fragment } from 'react';

import useHeader from './UseHeader';

import Shield from '../Shield';
import TopHeader from './topHeader/TopHeader';
import BottomHeader from './bottomHeader/BottomHeader';
import SessionEnding from './sessionEnding/SessionEnding';
import TitlePic from './dataHubSwimmerIcon/DataHubSwimmerIconPic';
import SessionDebugTimer from './sessionEnding/components/sessionTimer/SessionDebugTimer';

import UserIcon from '../../icons/UserIcon';

import style from './Header.module.css';
import { getConfig } from '../../../config/RuntimeConfig';

const Header = ({ showSessionEnding, setShowSessionEnding }) => {
  const { isUnregisteredUser, isSessionDebugTimerEnabled, hasBeenClicked, onLogoutClicked } = useHeader();

  if (isUnregisteredUser === true) {
    return (
      <header>
        <Shield className={style.Shield} />
        <nav className={style.TopHeader}>
          <ul>
            <li><button onClick={onLogoutClicked}><UserIcon tooltip="Log Out" />&nbsp;Log Out</button></li>
          </ul>
        </nav>
        <div className={[style.LargeBottomHeader, 'hidden-xs hidden-sm'].join(' ')}>
          <div className={style.Primary}>
            &nbsp;
          </div>
        </div>
        <div className={[style.SmallBottomHeader, 'visible-xs visible-sm'].join(' ')}>
          &nbsp;
        </div>
      </header>
    );
  }

  return (
    <Fragment>
      <header>
        <Shield className={style.Shield} />
        {isSessionDebugTimerEnabled === true && showSessionEnding !== true && <SessionDebugTimer setShowSessionEnding={setShowSessionEnding} />}
        <TopHeader />
        <BottomHeader />
        {showSessionEnding === true && <SessionEnding setShowSessionEnding={setShowSessionEnding} />}
      </header>
      {getConfig().VITE_TIMES_MICROSITE_UI_DOMAIN === 'self' &&
        <div className={style.DataHubContainer} onClick={hasBeenClicked}>
          <img width={'100%'} height={'300px'} src={`${getConfig().VITE_CDN_URL}/UnderwaterLaneLines.jpg`} />
          <div className={style.DataHubCenteredText}>
            <span><TitlePic /><span className='hidden-xs'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span className={style.DataHubTitleFont}>Data&nbsp;Hub</span></span>
          </div>
        </div>
      }
    </Fragment>
  );
};

export default Header;